export const PAE_HERO_SESSIONS_STATE = {
  none: 'none',
  single: 'single',
  multiple: 'multiple',
  unlimited: 'unlimited',
} as const;

export type PaeHeroSessionsState =
  (typeof PAE_HERO_SESSIONS_STATE)[keyof typeof PAE_HERO_SESSIONS_STATE];

export interface PaeHeroSessionsModel {
  state: PaeHeroSessionsState;
  multipleCount: number;
}
